module.exports = {"views.checkoutSuccessMeditationStudio.success.heading":"Erfolg!","views.checkoutSuccessMeditationStudio.success.body":"Ihr Abonnement wurde erfolgreich aktiviert. "}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/de/views/CheckoutSuccessMeditationStudio.json
// module id = 859
// module chunks = 0